import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Certificate = ({
  title,
  iconUrl,
  width = '100%'
}) => {
  const theme = useTheme();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs("svg", {
      fill: "none",
      height: "100%",
      style: {
        boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.3)',
        background: theme.color['fill-surface-default'],
        borderRadius: 8,
        width
      },
      viewBox: "0 0 310 240",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsxs("g", {
        id: "Certificate template 1",
        children: [/*#__PURE__*/_jsx("rect", {
          fill: theme.color['fill-surface-default'],
          height: "240",
          width: "310"
        }), /*#__PURE__*/_jsx("path", {
          d: "M35.3509 180.682H274.649",
          id: "Vector",
          stroke: theme.color['border-core-default'],
          strokeLinecap: "square"
        }), /*#__PURE__*/_jsx("path", {
          d: "M35.3509 77.8636H274.649",
          id: "Vector_2",
          stroke: theme.color['border-core-default'],
          strokeLinecap: "square"
        }), /*#__PURE__*/_jsx("path", {
          d: "M168.325 19.0909H141.675V45.8182H168.325V19.0909Z",
          fill: "url(#pattern0)",
          id: "Logo"
        }), /*#__PURE__*/_jsx("text", {
          fill: theme.color['text-core-default'],
          fontFamily: theme.typography['heading-25'].fontFamily,
          fontSize: theme.typography['heading-25'].fontSize,
          id: "title",
          textAnchor: "middle",
          xmlSpace: "preserve",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "50%",
            y: "65.5909",
            children: title
          })
        }), /*#__PURE__*/_jsx("foreignObject", {
          height: "103",
          width: "240",
          x: "35",
          y: "77",
          children: /*#__PURE__*/_jsx("div", {
            style: {
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              padding: '10px 18px'
            },
            children: /*#__PURE__*/_jsx("p", {
              style: {
                color: theme.color['text-core-default'],
                fontSize: '8px',
                lineHeight: '12px',
                textAlign: 'center',
                marginBottom: 0
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.certificate.body"
              })
            })
          })
        }), /*#__PURE__*/_jsx("text", {
          fill: theme.color['text-core-default'],
          fontFamily: theme.typography['detail-100'].fontFamily,
          fontSize: "4",
          id: "CEO",
          letterSpacing: "0em",
          xmlSpace: "preserve",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "236",
            y: "215.955",
            children: "CEO Yamini Rangan"
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "Hubspot_logo 1",
          children: /*#__PURE__*/_jsx("g", {
            id: "User-Guide-Academy-Prominence-STATS",
            children: /*#__PURE__*/_jsx("g", {
              id: "Artboard",
              children: /*#__PURE__*/_jsxs("g", {
                id: "Hubspot_logo",
                children: [/*#__PURE__*/_jsx("path", {
                  clipRule: "evenodd",
                  d: "M39.9985 206.833V209.905H37.2873V206.833H36V214.167H37.2873V211.194H39.9985V214.167H41.2857V206.833H39.9985Z",
                  fill: "#34475B",
                  fillRule: "evenodd",
                  id: "Fill1"
                }), /*#__PURE__*/_jsx("path", {
                  clipRule: "evenodd",
                  d: "M45.1882 211.837C45.1882 212.454 44.7165 212.954 44.1346 212.954C43.5527 212.954 43.081 212.454 43.081 211.837V208.67H41.873V211.837C41.8732 213.16 42.8849 214.233 44.1327 214.233C45.3804 214.233 46.3916 213.16 46.3918 211.837V208.67H45.1882V211.837Z",
                  fill: "#34475B",
                  fillRule: "evenodd",
                  id: "Fill2"
                }), /*#__PURE__*/_jsx("path", {
                  clipRule: "evenodd",
                  d: "M49.7788 212.943C49.0206 212.943 48.406 212.291 48.406 211.487C48.406 210.683 49.0206 210.031 49.7788 210.031C50.5369 210.031 51.1515 210.683 51.1515 211.487C51.1515 212.291 50.5369 212.943 49.7788 212.943ZM49.7862 208.707C49.1879 208.707 48.7704 208.891 48.3667 209.311V206.878H47.1568V211.389C47.1568 213.077 48.3081 214.234 49.6016 214.234C51.0367 214.234 52.299 213.057 52.299 211.471C52.299 209.906 51.1371 208.708 49.7862 208.708",
                  fill: "#34475B",
                  fillRule: "evenodd",
                  id: "Fill8"
                }), /*#__PURE__*/_jsx("path", {
                  clipRule: "evenodd",
                  d: "M54.1384 208.996C54.1384 208.347 54.5434 208.142 54.987 208.142C55.3446 208.142 55.8169 208.43 56.1258 208.78L56.917 207.791C56.522 207.225 55.7208 206.833 55.065 206.833C53.7547 206.833 52.8069 207.647 52.8069 208.996C52.8069 211.5 55.6921 210.706 55.6921 212.107C55.6921 212.539 55.2965 212.92 54.8435 212.92C54.1291 212.92 53.8976 212.55 53.5694 212.158L52.6914 213.126C53.253 213.857 53.9456 214.229 54.7755 214.229C56.0204 214.229 57.0218 213.405 57.0218 212.117C57.0218 209.338 54.1366 210.201 54.1366 208.996",
                  fill: "#34475B",
                  fillRule: "evenodd",
                  id: "Fill4"
                }), /*#__PURE__*/_jsx("path", {
                  clipRule: "evenodd",
                  d: "M61.7777 211.388C61.7777 212.192 61.1631 212.844 60.405 212.844C59.6469 212.844 59.0323 212.192 59.0323 211.388C59.0323 210.584 59.6469 209.932 60.405 209.932C61.1631 209.932 61.7777 210.584 61.7777 211.388ZM62.9233 211.404C62.9233 209.816 61.6635 208.641 60.2259 208.641C58.9324 208.641 57.7812 209.798 57.7812 211.486V216H58.9911V213.563C59.3942 213.982 59.8122 214.167 60.41 214.167C61.7608 214.167 62.9227 212.97 62.9227 211.404",
                  fill: "#34475B",
                  fillRule: "evenodd",
                  id: "Fill10"
                }), /*#__PURE__*/_jsxs("g", {
                  id: "O",
                  children: [/*#__PURE__*/_jsx("mask", {
                    height: "11",
                    id: "mask0_4_8",
                    maskUnits: "userSpaceOnUse",
                    width: "11",
                    x: "59",
                    y: "205",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "mask-2",
                      children: /*#__PURE__*/_jsx("path", {
                        d: "M59.4921 205H69.4215V215.918H59.4921V205Z",
                        fill: "white",
                        id: "Vector_3"
                      })
                    })
                  }), /*#__PURE__*/_jsx("g", {
                    mask: "url(#mask0_4_8)",
                    children: /*#__PURE__*/_jsx("path", {
                      clipRule: "evenodd",
                      d: "M66.7054 212.868C65.9363 212.868 65.3127 212.213 65.3127 211.406C65.3127 210.599 65.9363 209.945 66.7054 209.945C67.4744 209.945 68.0979 210.599 68.0979 211.406C68.0979 212.213 67.4744 212.868 66.7054 212.868ZM67.1223 208.593V207.294C67.4456 207.133 67.6722 206.79 67.6722 206.392V206.362C67.6722 205.812 67.2434 205.362 66.7196 205.362H66.691C66.1671 205.362 65.7384 205.812 65.7384 206.362V206.392C65.7384 206.79 65.965 207.133 66.2883 207.294V208.593C65.8069 208.671 65.367 208.88 65.0041 209.186L61.6028 206.41C61.6252 206.32 61.6409 206.227 61.6411 206.129C61.6418 205.506 61.1614 205.001 60.5679 205C59.9745 204.999 59.4928 205.503 59.4921 206.126C59.4913 206.749 59.9718 207.254 60.5652 207.255C60.7586 207.255 60.9376 207.197 61.0945 207.104L64.4403 209.835C64.1557 210.286 63.9891 210.825 63.9891 211.406C63.9891 212.015 64.1723 212.578 64.4818 213.04L63.4643 214.108C63.3839 214.083 63.3004 214.065 63.212 214.065C62.7244 214.065 62.3291 214.48 62.3291 214.992C62.3291 215.503 62.7244 215.918 63.212 215.918C63.6997 215.918 64.095 215.503 64.095 214.992C64.095 214.899 64.0781 214.811 64.054 214.727L65.0605 213.671C65.5173 214.037 66.0862 214.257 66.7054 214.257C68.2055 214.257 69.4215 212.981 69.4215 211.406C69.4215 209.982 68.4239 208.804 67.1223 208.593Z",
                      fill: "#F3785B",
                      fillRule: "evenodd",
                      id: "Fill1_2"
                    })
                  })]
                }), /*#__PURE__*/_jsx("path", {
                  clipRule: "evenodd",
                  d: "M72.3224 213.046C71.6087 213.046 71.4059 212.719 71.4059 212.217V209.997H72.5152V208.872H71.4059V207.388L70.181 207.971V212.493C70.181 213.65 70.9335 214.233 71.9655 214.233C72.1274 214.236 72.2892 214.222 72.4485 214.192L72.7473 213.025C72.6126 213.035 72.4578 213.045 72.3224 213.045",
                  fill: "#34475B",
                  fillRule: "evenodd",
                  id: "Fill6"
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx("text", {
          fill: theme.color['text-core-default'],
          fontFamily: theme.typography['detail-200'].fontFamily,
          fontSize: "9",
          id: "Academy",
          letterSpacing: "0em",
          xmlSpace: "preserve",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "76",
            y: "213.773",
            children: "Academy"
          })
        }), /*#__PURE__*/_jsxs("g", {
          id: "Group",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M267.838 200.323C267.482 200.678 267.4 201.636 267.729 201.636C268.166 201.636 269.152 200.761 269.152 200.377C269.152 199.912 268.303 199.858 267.838 200.323Z",
            fill: theme.color['text-core-default'],
            id: "Vector_4"
          }), /*#__PURE__*/_jsx("path", {
            d: "M259.93 200.979C259.656 201.746 260.915 202.184 261.763 201.636C262.119 201.39 262.091 201.308 261.654 200.952C260.942 200.405 260.149 200.432 259.93 200.979Z",
            fill: theme.color['text-core-default'],
            id: "Vector_5"
          }), /*#__PURE__*/_jsx("path", {
            d: "M231.826 201.773C230.294 202.813 224 209.955 224 210.667C224 211.487 224.985 210.667 226.682 208.395C228.844 205.549 231.799 202.238 232.018 202.457C232.1 202.539 231.142 203.825 229.856 205.33C227.284 208.313 226.299 209.764 226.6 210.065C226.709 210.174 227.12 209.846 227.53 209.326C227.913 208.833 229.227 207.219 230.403 205.768C232.51 203.223 233.578 201.718 233.578 201.28C233.578 200.897 232.811 201.089 231.826 201.773Z",
            fill: theme.color['text-core-default'],
            id: "Vector_6"
          }), /*#__PURE__*/_jsx("path", {
            d: "M235.411 201.527C235.302 201.636 235.219 201.992 235.219 202.32C235.219 202.621 234.426 204.236 233.468 205.85C232.51 207.465 231.553 209.189 231.361 209.654C231.17 210.147 230.431 211.296 229.692 212.226C227.858 214.552 226.08 218.028 225.259 220.901C224.41 223.774 224.356 225.142 225.04 225.991L225.56 226.62L226.189 225.717C226.545 225.197 228.378 221.831 230.239 218.219C234.316 210.283 235.493 208.286 238.12 204.756C239.215 203.251 240.118 201.883 240.145 201.691C240.172 200.761 239.133 201.746 236.123 205.631C234.262 208.012 232.565 209.764 232.346 209.517C232.264 209.435 232.784 208.45 233.523 207.355C236.259 203.196 236.943 201.609 236.04 201.417C235.794 201.39 235.52 201.417 235.411 201.527ZM233.578 209.955C233.578 210.01 233.003 211.022 232.319 212.172C231.635 213.348 229.911 216.605 228.515 219.451C227.092 222.269 225.806 224.65 225.642 224.759C225.286 224.978 225.286 224.978 225.779 222.543C226.299 220.08 227.639 216.878 229.062 214.634C230.54 212.336 233.578 209.189 233.578 209.955Z",
            fill: theme.color['text-core-default'],
            id: "Vector_7"
          }), /*#__PURE__*/_jsx("path", {
            d: "M266.716 204.236C264.062 206.617 263.405 206.863 264.39 205.084C265.293 203.47 264.773 203.114 263.514 204.455C262.475 205.549 260.285 207.383 260.012 207.383C259.601 207.383 259.902 205.796 260.532 204.701C261.106 203.689 261.134 203.497 260.778 203.36C260.504 203.278 259.957 203.579 259.355 204.154C258.096 205.358 255.305 207.383 254.922 207.383C254.402 207.383 254.648 206.808 255.743 205.631C256.345 204.975 256.837 204.373 256.837 204.263C256.837 203.771 255.661 204.208 254.484 205.139C253.061 206.261 249.504 208.477 249.121 208.477C248.683 208.477 248.929 207.848 250.024 206.343C251.419 204.373 250.954 204.154 249.066 205.932C246.822 208.067 246.165 208.587 246.001 208.395C245.892 208.313 246.466 207.355 247.26 206.316C248.026 205.248 248.628 204.236 248.573 204.099C248.519 203.935 248.026 204.126 247.479 204.564C242.471 208.45 241.787 208.888 241.787 208.258C241.787 208.122 242.143 207.547 242.608 206.945C243.429 205.878 243.648 205.194 243.183 205.194C243.018 205.194 242.827 205.303 242.745 205.467C242.663 205.604 242.362 205.741 242.115 205.741C241.787 205.741 241.76 205.659 242.006 205.413C242.498 204.92 242.416 204.373 241.842 204.373C240.939 204.373 238.777 206.042 237.682 207.602C236.478 209.271 236.314 210.01 237.108 210.256C237.682 210.42 239.871 209.654 239.871 209.271C239.871 208.751 240.72 208.696 241.24 209.161C241.732 209.599 241.814 209.599 242.799 208.997C243.374 208.669 244.195 208.094 244.633 207.739C245.071 207.383 245.454 207.137 245.509 207.191C245.591 207.246 245.426 207.739 245.208 208.286C244.441 210.119 244.742 210.283 246.576 209.025C247.233 208.559 247.835 208.204 247.917 208.204C247.999 208.204 248.081 208.559 248.081 209.025C248.081 209.462 248.136 209.846 248.218 209.846C248.491 209.846 250.68 208.669 252.131 207.766C252.924 207.246 253.636 206.835 253.691 206.835C253.773 206.835 253.827 207.219 253.827 207.684C253.827 208.505 253.882 208.532 254.676 208.368C255.141 208.286 256.208 207.711 257.084 207.109C257.932 206.507 258.698 206.015 258.753 206.015C258.835 206.015 258.89 206.48 258.89 207.027C258.89 207.903 258.999 208.094 259.547 208.149C259.902 208.204 260.751 207.903 261.544 207.383C262.776 206.644 262.967 206.589 263.378 206.945C264.007 207.492 265.184 206.945 266.935 205.33L268.303 204.044L268.495 204.756C268.741 205.768 269.124 205.96 271.094 206.179C272.517 206.316 273.119 206.261 273.886 205.878C275.117 205.303 275.281 204.482 274.159 204.756C273.721 204.865 272.49 205.002 271.423 205.112L269.425 205.276V204.072C269.425 201.992 269.179 201.992 266.716 204.236ZM241.513 206.124C241.513 206.835 239.954 208.423 238.531 209.161C237.135 209.873 237.463 208.97 239.269 207.109C240.993 205.33 241.513 205.112 241.513 206.124Z",
            fill: theme.color['text-core-default'],
            id: "Vector_8"
          }), /*#__PURE__*/_jsx("path", {
            d: "M231.388 205.467C231.087 205.659 231.06 205.796 231.306 206.042C231.717 206.452 232.62 206.233 232.62 205.741C232.62 205.248 231.963 205.084 231.388 205.467Z",
            fill: theme.color['text-core-default'],
            id: "Vector_9"
          })]
        })]
      }), /*#__PURE__*/_jsxs("defs", {
        children: [/*#__PURE__*/_jsx("pattern", {
          height: "1",
          id: "pattern0",
          patternContentUnits: "objectBoundingBox",
          width: "1",
          children: /*#__PURE__*/_jsx("use", {
            transform: "scale(0.00136986)",
            xlinkHref: "#image0_4_8"
          })
        }), /*#__PURE__*/_jsx("image", {
          "data-name": "image2_0_2.png",
          height: "717",
          id: "image0_4_8",
          width: "730",
          xlinkHref: iconUrl
        })]
      })]
    })
  );
};
export default Certificate;